import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router
} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ClientGuard implements CanActivate {

    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {

        const base = localStorage.getItem('apiURL');

        let clientName = '';

        if (base) {
            try {
                const url = new URL(base);
                const parts = url.hostname.split('.');

                clientName = parts.length >= 2
                    ? parts[1].toLowerCase()
                    : '';
                console.log(clientName);

            }
            catch {
                clientName = '';
            }finally{   
                console.log(clientName);
            }
        }

        const allowedClients: string[] =
            route.data?.['allowedClients'] ?? [];

        const excludedClients: string[] =
            route.data?.['excludedClients'] ?? [];

        if (
            allowedClients.length > 0 &&
            !allowedClients
                .map(x => x.toLowerCase())
                .includes(clientName)
        ) {
            this.router.navigate(['/404-not-found']);
            return false;
        }

        if (
            excludedClients
                .map(x => x.toLowerCase())
                .includes(clientName)
        ) {
            this.router.navigate(['/404-not-found']);
            return false;
        }

        return true;
    }
}